module.exports = __webpack_public_path__ + "img/plane-b777er.a5658fae.svg";